<template>
    <div class="form-line" v-bind:class="{ focused: isFocus }">
        <input @focus="focus" @blur="blur" v-bind="$attrs" class="form-control"  v-model="isi">
    </div>
</template>

<script>
  export default {
    name: 'FormLine',
    props: [
      'value', 'col'
    ],
    data: function () {
      return {
        isFocus: false,
        isi: this.value
      }
    },
    methods: {
      focus () {
        this.isFocus = true
      },
      blur () {
        this.isFocus = false
      }
    },
    mounted: function () {
    },
    watch: {
      isi: function (val) {
        this.$emit('input', val)
      },
      value: function (val) {
        this.isi = val
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/FormLine.vue?f3e9c8b4